import type { Lang } from '../i18n/types';

export type BlogListItem = {
  id: number;
  title: string;
  cover_image: string | null;
  excerpt: string | null;
  meta_description?: string | null;
  keywords?: string | null;
  og_image?: string | null;
  lang: Lang;
  published_at: string | null;
  updated_at: string;
};

export type BlogPost = BlogListItem & {
  content_md: string;
  status: string;
  created_at: string;
};

export type BlogListResponse = {
  ok: boolean;
  lang: Lang;
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  posts: BlogListItem[];
};

export async function fetchBlogList(lang: Lang, page: number, limit = 9): Promise<BlogListResponse> {
  const q = new URLSearchParams({ lang, page: String(page), limit: String(limit) });
  const res = await fetch(`/api/blogs?${q}`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error('blog_list_failed');
  return res.json() as Promise<BlogListResponse>;
}

export async function fetchBlogPost(lang: Lang, id: number): Promise<BlogPost> {
  const q = new URLSearchParams({ lang });
  const res = await fetch(`/api/blogs/${id}?${q}`, {
    headers: { Accept: 'application/json' },
  });
  if (res.status === 404) throw new Error('not_found');
  if (!res.ok) throw new Error('blog_post_failed');
  const data = (await res.json()) as { ok: boolean; post: BlogPost };
  return data.post;
}

export async function recordBlogView(lang: Lang, id: number): Promise<void> {
  const q = new URLSearchParams({ lang });
  await fetch(`/api/blogs/${id}/view?${q}`, { method: 'POST' });
}
